const ModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '45%',
    backgroundColor: '#494949',
    color: "#B8B8B8",
    boxShadow: 24,
    borderRadius: 10,
    padding: "35px 40px",
};

export { ModalStyle }